import React from 'react';

// Ảnh trong public/images/<path>.{webp,jpg} (tạo bởi scripts/optimize-images.js)
function Picture({ path, alt, width, height, className = '', eager = false }) {
  const src = `${process.env.PUBLIC_URL}/images/${path}`;
  return (
    <picture>
      <source srcSet={`${src}.webp`} type="image/webp" />
      <img
        src={`${src}.jpg`}
        alt={alt}
        width={width}
        height={height}
        className={className}
        loading={eager ? 'eager' : 'lazy'}
        fetchpriority={eager ? 'high' : undefined}
        decoding="async"
      />
    </picture>
  );
}

export default Picture;
